<template>
  <div>
    <a-drawer
      title="文章详情"
      :placement="'right'"
      :visible="articleVis"
      :width="1100"
      @close="onClose"
    >
      <div class="detail">
        <div class="toolbar">
          <a-button type="primary" @click="cancelModal">选择推送区域</a-button>
        </div>
        <div v-if="article.title != undefined && article.title != ''">
          <div class="title">
            <h1>{{ article.title }}</h1>
          </div>
          <div class="subtitle" v-if="article.subtitle != 'undefined'">
            <h3>{{ article.subtitle }}</h3>
          </div>
          <div class="info">
            <span>
              文章ID：
              <code>{{ article.id }}</code>
            </span>
            <span v-if="article.adduser">作者：{{ article.adduser }}</span>
            <span>发布时间：{{ article.pubtime }}</span>
          </div>
          <div>
            <video
              v-show="article.attach != ''"
              width="400"
              height="300"
              class="video"
              poster
              controls
              preload
              :src="videoSrc"
            ></video>
          </div>
          <div v-if="article.linkurl" style="margin:50px;">
            <a-button block @click="openlink">打开外部链接</a-button>
          </div>
          <div class="content" v-html="article.content" v-else></div>
        </div>
        <div
          style="width:100%;height:400px;text-align: center;line-height:400px;"
          v-else
        >
          <a-spin size="large" tip="数据加载中..." />
        </div>
      </div>

      <a-modal
        title="选择区域"
        :visible="visible"
        @ok="complete"
        @cancel="visible = false"
      >
        <div>
          <a-form
            :form="form"
            layout="horizontal"
            @submit="complete"
            :maskClosable="false"
          >
            <a-form-item
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 18 }"
              label="文章阅读数："
            >
              <a-input-number
                :max-length="120"
                :min="0"
                v-decorator="[
                  'num',
                  {
                    rules: [
                      {
                        required: true,
                        message: '文章阅读数必填'
                      }
                    ],
                    initialValue: '0'
                  }
                ]"
                placeholder="请输入阅读数量"
              />
            </a-form-item>
            <a-form-item
              :label="item.title + '：'"
              v-for="item in listMedia"
              :key="item.id"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 16 }"
            >
              <a-input v-decorator="[item.type]" placeholder="请输入推送地址" />
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </a-drawer>
  </div>
</template>

<script>
export default {
  name: 'Preview',
  data() {
    return {
      lists: [],
      loading: false,
      article: {},
      cateName: [],
      videoSrc: '',
      visible: false,
      platformData: undefined,
      listMedia: [
        { title: '新华号', type: 'xh', id: 5 },
        { title: '人民号', type: 'rmw', id: 6 },
        { title: '央视新闻+', type: 'cctv', id: 0 },
        { title: '学习强国', type: 'xxqg', id: 9 },
        { title: '澎湃问政', type: 'thepaper', id: 3 },
        { title: '长江云', type: 'cjyun', id: 10 },
        { title: '今日头条', type: 'toutiao', id: 1 },
        { title: '搜狐号', type: 'sohu', id: 2 },
        { title: '百家号', type: 'baijia', id: 4 },
        { title: '抖音', type: 'dy', id: 13 },
        { title: 'bilibili', type: 'bilibili', id: 7 },
        { title: '优酷视频', type: 'youku', id: 8 },
        { title: '爱奇艺', type: 'iqiyi', id: 11 },
        { title: '腾讯视频', type: 'tencent', id: 12 }
      ],
      form: this.$form.createForm(this)
    };
  },
  props: ['catesingle', 'articleId', 'articleVis', 'catid'],
  created() {},
  watch: {
    articleId(value) {
      if (value != 0) {
        this.loadDetail(value);
        this.getPlatform(value);
      }
    }
  },
  methods: {
    handleMenuClick() {},
    //预览
    openlink() {
      window.open(this.article.linkurl);
    },
    getCatename(cataid) {
      this.cateName = [];
      this.catesingle.forEach(res => {
        if (cataid.indexOf(parseInt(res.catid)) >= 0) {
          this.cateName.push({ catid: res.catid, catname: res.catname });
        }
      });
    },
    loadDetail(id) {
      this.article = {};
      this.$http.post('/api/content/clouddetail', { id: id }).then(res => {
        this.article = res.data.data;
        this.getCatename(this.article.catid);
        if (this.article.attach != '') {
          this.videoSrc = this.article.attach;
        }
        let imgReg = /<img.*?(?:>|\/>)/gi;
        let classReg = /class=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let idReg = /id=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let arr = this.article.content.match(imgReg);
        for (let i in arr) {
          let classMatch = arr[i].match(classReg);
          if (
            classMatch != null &&
            typeof classMatch[1] != 'undefined' &&
            classMatch[1].substr(0, 6) == 'ycrmt_'
          ) {
            let idMatch = arr[i].match(idReg);
            if (
              idMatch != null &&
              typeof idMatch[1] != 'undefined' &&
              idMatch[1] != ''
            ) {
              let height = 320;
              if (classMatch[1].substr(-5) == 'audio') height = 40;
              let htmlStr =
                '<iframe src="https://web.ycrmt.cn/play/' +
                classMatch[1].substr(-5) +
                '?id=' +
                idMatch[1] +
                '" frameborder="0" width="480" height="' +
                height +
                '"></iframe>';
              this.article.content = this.article.content.replace(
                new RegExp(arr[i], 'g'),
                htmlStr
              );
            }
          }
        }
        this.article.content = this.article.content.replace(
          /class=/g,
          '_class='
        );
      });
    },
    onClose() {
      this.$emit('close');
    },
    cancelModal() {
      this.visible = true;
      if (this.platformData) {
        let data = this.platformData.lists;
        let obj = {};
        data.forEach(item => {
          obj[item.type] = item.linkurl;
        });
        obj.num = this.platformData.num;
        this.$nextTick(() => {
          this.form.setFieldsValue(obj);
        });
      } else {
        this.$nextTick(() => {
          this.form.resetFields();
        });
      }
    },
    getPlatform(id) {
      this.$http
        .post('http://web.ycrmt.cn/api/getPlatform', {
          id
        })
        .then(res => {
          if (res.data.state == 200) {
            this.platformData = res.data.data;
          } else {
            this.platformData = undefined;
          }
        });
    },
    complete(e) {
      let that = this;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = {
            id: that.articleId,
            num: values.num
          };
          let initMenu = that.removeEmptyField(values);
          let lists = [];
          delete initMenu.num;
          for (let key in initMenu) {
            lists.push({
              type: key,
              linkurl: initMenu[key]
            });
          }
          data.lists = JSON.stringify(lists);
          that.$http.post('api/content/appExtend', data).then(res => {
            if (res.data.state == 200) {
              that.$message.success('添加成功');
              that.visible = false;
              that.getPlatform(that.articleId);
            }
          });
        }
      });
    },
    removeEmptyField(obj) {
      var newObj = {};
      if (typeof obj == 'string') {
        obj = JSON.parse(obj);
      }
      if (obj instanceof Array) {
        newObj = [];
      }
      if (obj instanceof Object) {
        for (var attr in obj) {
          if (
            obj.hasOwnProperty(attr) &&
            obj[attr] !== '' &&
            obj[attr] !== null &&
            obj[attr] !== undefined
          ) {
            if (obj[attr] instanceof Object) {
              newObj[attr] = removeEmptyField(obj[attr]);
            } else if (
              typeof obj[attr] == 'string' &&
              ((obj[attr].indexOf('{') > -1 && obj[attr].indexOf('}') > -1) ||
                (obj[attr].indexOf('[') > -1 && obj[attr].indexOf(']') > -1))
            ) {
              try {
                var attrObj = JSON.parse(obj[attr]);
                if (attrObj instanceof Object) {
                  newObj[attr] = removeEmptyField(attrObj);
                }
              } catch (e) {
                newObj[attr] = obj[attr];
              }
            } else {
              newObj[attr] = obj[attr];
            }
          }
        }
      }
      return newObj;
    }
  }
};
</script>

<style scoped>
.detail .info span {
  color: #999aa5;
  margin-right: 10px;
}
.detail .content {
  text-indent: 2rem;
  margin-top: 10px;
  font-size: 16px;
  line-height: 28px;
  /*position: absolute;*/
  top: 160px;
  right: 0;
  bottom: 60px;
  left: 0;
}
.detail .content img {
  text-align: center;
}

.detail .delete {
  color: #ff6e32;
}

.detail .edit {
  color: #52c41a;
}

.detail .edit {
  color: #52c41a;
}
.detail .title {
  line-height: 50px;
}
.detail .toolbar .menu:hover,
.detail .toolbar .current {
  background-color: #eeeeee;
}
.push-nav {
  top: -1px;
  left: -10px;
  display: none;
  width: 150px;
  background: #fff;
  z-index: 1000;
  position: relative;
}
.active,
.active > .pubtime,
.active > .user {
  color: #fff;
}

.row .title {
  font-size: 16px;
  min-height: 50px;
}

.row .title i {
  margin-right: 5px;
}

.row .info {
  font-size: 13px;
  height: 24px;
  line-height: 24px;
  color: #c0c4cc;
}

.row .info .pubtime {
  text-align: left;
}
.row .info .user {
  text-align: right;
}

.detail {
  width: 100%;
  position: relative;
}
.detail .toolbar {
  text-align: right;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.detail .toolbar i {
  margin-right: 5px;
}

.detail .toolbar .menu {
  float: right;
  cursor: pointer;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 70px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
.catesubmit {
  border-top: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}
.catesubmit:hover {
  color: #fff;
  border-radius: 3px;
  background: #409eff;
}
.option {
  height: 60px;
  line-height: 60px;
  /* border-bottom: 1px solid #e8e8e8; */
}
.option .dropdown {
  width: 100px;
  position: absolute;
  top: 14px;
  text-align: left;
}
.option .dropdown .button {
  padding-left: 10px;
  text-align: left;
  overflow-x: hidden;
}
.option .dropdown .text {
  width: 80px;
  overflow-x: hidden;
  height: 30px;
  line-height: 30px;
  text-overflow: ellipsis;
}
.option .dropdown .icon {
  position: absolute;
  right: 5px;
  top: 10px;
}
.option .search {
  width: 195px;
  position: absolute;
  left: 115px;
  top: 14px;
}
.logs {
  background-color: #fff;
  position: absolute;
  z-index: 999;
  width: 320px;
  top: 128px;
  right: 14px;
  overflow-y: auto;
  transition: all 2s;
  -moz-transition: all 2s; /* Firefox 4 */
  -webkit-transition: all 2s; /* Safari 和 Chrome */
  -o-transition: all 2s; /* Opera */
}
.log-content {
  padding: 10px 0 0 10px;
}
</style>
